import { SearchedUser } from '../services/usersService/usersServiceQuery';
import Store from '../store';
import { ValidationErrors } from './core/validation';

export const processAndRemoveElements = <T>(arr: Array<T>, process: (el: T) => void): Array<unknown> => {
  if (arr.length > 0) {
    const el = arr.pop();
    el && process(el);
    return processAndRemoveElements(arr, process);
  }
  return [];
};

export const parseErrors = (errors: ValidationErrors) =>
  errors?.reduce((acc, error) => {
    const key: string = error.schemaPath.includes('required')
      ? (error.params.missingProperty as string)
      : error.instancePath.split('/').pop() ?? 'bad_path';

    return { ...acc, [key]: { message: error.message, keyword: error.keyword } };
  }, {});

export const checkPermissions = (users: Partial<SearchedUser>[]) =>
  users
    .map((user, cardNo) => {
      if (!user.roles || user.roles.length < 1) {
        return cardNo;
      }
      return -1;
    })
    .filter((index) => index !== -1);

// Remember, 0 is false.
export const safeTruthy = (arg: unknown) => typeof arg !== 'undefined' && arg !== null;

export enum AUTHORIZATION_PERMISSIONS {
  MANAGE_ROLE = 'carrierpro.ManageRoles',
  DELETE_PERMISSION = 'internal.PermissionsDelete',
}

export enum PERMISSIONS {
  REP_COMPANY_ADMIN = 'carrierpro.RepCompanyAdmin',
  COMPANY_ADMIN = 'carrierpro.CompanyAdmin',
  CARD_LOCK_EXTERNAL = 'fuel.CardLockExternal',
  CARD_LOCK_EMULATION = 'fuel.CardLockEmulation',
  CARDS_SIDE_PANEL_READ = 'fuel.fraud_prevention.read',
  CARDS_SIDE_PANEL_ADMIN = 'fuel.fraud_prevention.admin',
}
export function isObjectEmptyStrict<T extends object>(obj: T): boolean {
  const keys = Object.keys(obj);

  if (keys.length === 0) return true;

  return keys.every((key) => !obj[key as keyof T]);
}

export function stripEmptyFields<T extends Record<string, unknown>>(obj: T): T {
  if (!obj) return {} as T;
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value === 'string' && value.trim().length === 0) return { ...acc, [key]: undefined };
    if (value === null) return { ...acc, [key]: undefined }; // Nulls break validation.
    return { ...acc, [key]: value };
  }, {}) as T;
}

//Use when hooks cannot be leveraged
export function isFeatureEnabled(feature: string): boolean {
  return Store.getState().adminShell.userFeatures.includes(feature);
}

export function auth0LoginRedirect(): Promise<void> {
  const redirectFn = Store.getState().adminShell.auth0LoginRedirect;
  if (redirectFn) {
    return redirectFn({ appState: { returnTo: window.location.pathname } });
  }
  return Promise.resolve();
}
